<template>
    <div class="h-full p-4">
        <div v-if="! isRunning" class="h-full flex flex-col justify-even items-center">
            <button class="button" @click="createGame">create game</button>
            <button class="button" @click="showJoinModal">join game</button>
        </div>

        <div v-if="isRunning" class="h-full flex flex-col justify-between">
            <div class="bg-yellow text-lg text-pink-dark text-center -m-4 px-4 py-2">
                Room ID: <strong class="font-mono" v-text="room"></strong>
            </div>


            <span
                :class="['text-5xl text-center select-none transition-all', {
                    blur: hideWord,
                    'opacity-0': hideWord,
                }]"
                v-text="theWord"
            ></span>

            <div class="flex justify-between">
                <button
                    class="button"
                    @touchstart.prevent="showWord = true"
                    @touchend="showWord = false"
                >Reveal word</button>
                <button
                    class="button"
                    @click="newRound"
                    v-if="player.isModerator"
                    :disabled="! words.length"
                >
                    <span v-if="round === null">start round</span>
                    <span v-else>next round</span>
                </button>
            </div>
        </div>

        <modal
            name="join-room"
            classes="bg-pink-dark p-8"
            width="90%"
            height="auto"
        >

            <div class="w-full flex justify-center flex-wrap -m-2">
                <input
                    type="text"
                    name="room_id"
                    id="room_id"
                    size="8"
                    v-model="room"
                    placeholder="Room ID"
                    autocomplete="off"
                    autocorrect="off"
                    autocapitalize="off"
                    spellcheck="false"
                    class="flex-1 max-w-full m-1 p-2 bg-transparent
                        border-yellow border-2 rounded
                        font-bold text-yellow text-4xl text-center"
                >
                <button class="button m-1" @click="joinRoom" :disabled="! validRoom">
                    join
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
import RoomId from '../utils/RoomId';

function random(collection) {
    return collection[Math.floor(Math.random() * collection.length)];
}

export default {
    data() {
        return {
            room: null,
            isRunning: false,
            showWord: true,
            player: {
                id: RoomId.generate(),
                isModerator: false,
            },
            players: [],
            words: [],
            round: null,
        }
    },

    computed: {
        validRoom() {
            return RoomId.isValid(this.room);
        },

        game() {
            if (! this.validRoom) {
                return null;
            }

            return firebase.database().ref(`rooms/${this.room}`);
        },

        hideWord() {
            return ! this.showWord;
        },

        theWord() {
            if (this.round == null) {
                return 'wait for next round';
            }

            if (this.hideTransitionRunning) {
                return '';
            }

            if (this.round.fakeArtist === this.player.id) {
                return 'Fake Artist';
            }

            return this.round.word;
        },
    },

    methods: {
        createGame() {
            this.player.isModerator = true;
            this.isRunning = true;
            this.room = RoomId.generate();
            this.game.child('players').on('child_added', this.playerAdded);
            this.game.child('players').on('child_removed', this.playerRemoved);
            this.game.child('players').push(this.player);
            this.game.onDisconnect().remove();

            axios.get('words')
                .then(({data}) => this.words = data)
                .catch(error => alert(error.request.statusText));
        },

        showJoinModal() {
            this.$modal.show('join-room');
        },

        hideJoinModal() {
            this.$modal.hide('join-room');
        },

        joinRoom() {
            this.isRunning = true;
            let playerRef = this.game.child('players').push(this.player);
            this.game.child('currentGame').on('value', this.startRound);
            this.hideJoinModal();
            playerRef.onDisconnect().remove();
        },

        toggleWord() {
            this.showWord = !this.showWord;
        },

        newRound() {
            this.showWord = false;
            this.round = {
                fakeArtist: random(this.players).id,
                word: random(this.words),
            }

            this.game.child('currentGame').set(this.round);
        },

        playerAdded(player) {
            this.players.push(player.val());
        },

        playerRemoved(player) {
            const removedPlayer = player.val();

            this.players.splice(
                this.players.findIndex(player => player.id === removedPlayer.id),
                1
            );
        },

        startRound(round) {
            this.showWord = false;
            this.round = round.val();
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/FakeArtist.vue